
<div class="main-container">
  <div class="main-titles">
  <h1>Welcome to your new one-stop solution</h1>
  <h2>Two tools, one site</h2>
  </div>
</div>